import { CurrencyPipe, isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  OnInit,
  PLATFORM_ID,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DocumentsService } from '@presentationServices';
import { NavbarComponent } from '@presentationShared';
import { EventsFacade } from '@presentationStore/events';
import { AppReadyService } from '@shared';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

@Component({
  selector: 'app-presentation',
  imports: [ RouterOutlet, NavbarComponent ],
  templateUrl: './presentation.component.html',
  styleUrl: './presentation.component.scss',
  providers: [ CurrencyPipe ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PresentationComponent implements OnInit, AfterViewInit {
  private readonly eventsFacade: EventsFacade = inject(EventsFacade);
  private readonly documentsService: DocumentsService = inject(DocumentsService);
  private readonly platformId: object = inject(PLATFORM_ID);
  private readonly appReady: AppReadyService = inject(AppReadyService);
  private readonly isBrowser = isPlatformBrowser(this.platformId);
  private animationsStarted = false;

  constructor() {
    effect(() => {
      if (this.appReady.isReady()) {
        this.startAnimations();
      }
    });
  }

  ngOnInit() {
    this.eventsFacade.loadUpcomingEvents(1);
    this.eventsFacade.loadInPreparationEvents(1);
    this.eventsFacade.loadPastEvents(1);
    this.documentsService.loadDocuments();
  }

  ngAfterViewInit() {
    if (!this.isBrowser) {
      return;
    }

    gsap.registerPlugin(ScrollTrigger);
  }

  private startAnimations(): void {
    if (!this.isBrowser || this.animationsStarted) {
      return;
    }

    this.animationsStarted = true;

    gsap.to('.show-after-delay-1-5', {
      duration: 0.5,
      autoAlpha: 1,
      delay: 0.3,
      ease: 'power1.out',
    });
  }
}
